import { loadView } from '@/router'

export default [
  {
    path: 'delivery-times',
    name: 'freight-deliverytimes',
    component: loadView('Application/Freight/DeliveryTimes'),
    showInAlfred: true,
    alfredTitle: 'Freight - Delivery Times'
  }
]
